export default "__VITE_ASSET__8d52e134__"